<template>
  <div class="flex items-center gap-4">
    <NAvatar label="PR" />

    <NAvatar src="/images/avatar.png" alt="Phojie Rengel" />
  </div>
</template>
